import type { Profile } from "@/hooks/useAuth";
import { statoAccesso } from "@/lib/statoAccesso";

/**
 * ⏸️ IL BANCO E' IN STANDBY (Davide, 08/09/2026, prima del lancio).
 *
 * «Tutto il codice che riguarda il banco per l'assistenza umana deve essere
 * messo in standby.» Il motivo non e' che funziona male: e' che la v1 parte
 * con l'assistente, e l'assistenza umana entra in scena solo quando avra' una
 * regola sua — quella scritta nella ROTTA del primo aggiornamento: dopo tre o
 * quattro risposte che non risolvono, l'installatore puo' passare alle persone
 * di Datacom, che rispondono dal lunedi' al venerdi', 9-13 e 15-18.
 *
 * COSA VUOL DIRE «STANDBY», QUI. Il codice resta tutto dov'e' — pagine, chat,
 * pannello, tabelle, policy: non si cancella niente, perche' quello che si
 * cancella si riscrive. Si spegne la PORTA, in un punto solo: questa funzione.
 * Con l'interruttore a `true` nessuno vede il banco: ne' l'installatore a cui
 * era stato concesso, ne' l'operatore Datacom, ne' l'admin. Le voci di menu'
 * spariscono, le due pagine rimandano indietro, la scheda del pannello non si
 * apre.
 *
 * COME SI RIACCENDE: si mette `BANCO_IN_STANDBY = false` e si ripubblica.
 * Nient'altro. Prima di farlo, due cose da sistemare (annotate nella rotta):
 * il passaggio automatico dopo N risposte insufficienti, e la prova sul
 * telefono della schermata del banco (il difetto della tacca dell'iPhone,
 * corretto l'08/09 ma mai visto su un dispositivo vero).
 */
export const BANCO_IN_STANDBY = true;

/**
 * Chi vede (e usa) la chat col banco Datacom.
 *
 * E' una CONCESSIONE, come i marchi (Davide, 01/09): spenta per tutti,
 * la accende Datacom dal pannello sul singolo cliente. La voce di menu',
 * la scheda negli strumenti e la pagina usano tutti QUESTA regola; il
 * database ne fa rispettare una copia nella policy di scrittura, cosi'
 * nessuno scrive al banco chiamando l'API a mano.
 */
export function bancoConcesso(profile: Profile | null, isAdmin: boolean): boolean {
  if (BANCO_IN_STANDBY) return false;
  if (isAdmin || profile?.banco_operatore) return true;
  return profile?.banco_abilitato === true && statoAccesso(profile) === "abbonato";
}

/**
 * Il banco e' governabile dal pannello admin? In standby no: una scheda che
 * concede un privilegio che poi non esiste e' peggio di una scheda assente.
 */
export function bancoGovernabile(): boolean {
  return !BANCO_IN_STANDBY;
}
